import { Injectable } from "@angular/core";
import { XsHttpApiService } from "../../common/services/xs-http-api.service";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";
import { PlusdCommonService } from "./plusd-common.service";

@Injectable({
  providedIn: "root"
})

export class CorreoService {
  constructor(
    public xsHttpApiService: XsHttpApiService,
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
  ) { }

  /*correoSimple(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/correo/correo-simple",
      parametro
    );
  }

  correoAvanzado(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/correo/correo-avanzado",
      parametro
    );
  }

  correoConfirmacion(parametro): any {
    parametro.ruc = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/correo/correo-confirmacion",
      parametro
    );
  }*/
}
